import styled from "styled-components";

export const Container = styled.div`
  width: 80%;
  padding-bottom: 3rem;
  display: flex;
  margin: 0 auto 2rem auto;
  grid-template-rows: auto 1fr auto;
  flex-direction: column;
  background-color: #f7f7f7;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  h1 {
    display: block;
    margin: 2rem 0;
  }
  .unactive {
    display: none;
  }
  .active {
    display: flex;
  }
`;
export const Grid = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 2%;
  min-height: 60vh;
  .titulo {
    grid-column: 1 / span 4;
    display: grid;
    grid-template-columns: 50% 50%;
    height: fit-content;
    border-bottom: 1px solid;
    margin-bottom: 40%;
    h1 {
      width: fit-content;
      font-family: "Blanco Regular";
    }
    p {
      width: fit-content;
      font-family: "Blanco Regular";
    }
    button {
      background-color: #ff6a00;
      width: 25%;
      height: 40px;
      border-radius: 10px;
      border-style: none;
      color: #fff;
      display: flex;
      align-self: center;
      justify-self: end;
      justify-content: center;
      align-items: center;
      margin-right: 5%;
    }
  }
  .NewProyect {
    background-color: #000;
    width: 97%;
    height: 200px;
    margin: 2%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 25px;
    color: #fff;
    .PlusIcon {
      font-size: 40px;
      display: inline-block;
      margin: 0;
    }
    p {
      font-size: 20px;
      margin: 0;
    }
  }
  .star-messagge {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #fff;
    border-radius: 45px;
    height: 20%;
    width: 90%;
    text-align: center;
    left: 30%;
    top: 40%;
  }
  @media only screen and (min-width: 867px) {
    display: ${(props) => (props.plays ? "grid" : "flex")};
    grid-template-columns: 25% 25% 25% 25%;
    grid-auto-rows: 290px;
    .NewProyect {
      height: 97%;
      margin: 2%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 25px;
      color: #fff;
      .PlusIcon {
        font-size: 40px;
        display: inline-block;
        margin: 0;
      }
      p {
        font-size: 20px;
        margin: 0;
      }
    }
    .star-messagge {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      background-color: #fff;
      border-radius: 45px;
      height: 20%;
      width: 40%;
      padding: 2rem 0;
      text-align: center;
      left: 30%;
      top: 40%;
    }
  }
`;
export const Sidebar = styled.div`
  background-color: #000;
  height: 100%;
  width: 20%;
  padding: 2% 3% 0 3%;
  h1 {
    color: #ccc;
    font-size: 20px;
    font-family: "Comic Neue Bold";
  }
  p {
    color: #fff;
    font-size: 16px;
    font-family: "Comic Neue Bold";
  }
`;

export const CreateProyectPopUp = styled.div`
  height: 100vh;
  width: 100vw;
  max-width: 350px;
  position: fixed;
  left: 0;
  top: 0;
  grid-template-rows: auto 1fr auto;
  justify-content: center;
  align-content: center;
  z-index: 15;
  .BlackBackground {
    width: 100vw;
    height: 100%;
    display: flex;
    position: absolute;
    left: 0;
    grid-template-rows: auto 1fr auto;
    background-color: #000;
    opacity: 0.5;
  }
  .PopUpContent {
    position: absolute;
    display: flex;
    align-self: center;
    justify-self: center;
    flex-direction: column;
    background-color: #fff;
    border-radius: 45px;
    height: fit-content;
    width: 80%;
    padding: 2rem 0;
  }
  .PopUpTitle {
    display: flex;
    border-radius: 45px 45px 0 0;
    width: 100%;
    background-color: #fff;
    margin: 0;
    text-align: center;
    justify-content: center;
    h1 {
      font-size: 20px;
      font-style: regular;
    }
  }
  .PopUpContainer {
    width: 75%;
    align-self: center;
  }
  .inputName {
    width: 100%;
    height: 30px;
  }
  .dobleSection {
    display: flex;
    div {
      width: 30%;
      height: 100%;
    }
    p {
      width: 100%;
    }
    input {
      width: 90%;
      height: 30px;
    }
  }
  .inputDescription {
    width: 100%;
    height: 70px;
  }
  .inputGoals {
    display: flex;
    width: 100%;
    height: 70px;
  }
  .buttonSection {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    button {
      font-size: 1rem;
      background-color: #000;
      color: #fff;
      border: 0;
      width: 40%;
      height: 30px;
      margin-top: 10px;
      padding: 1.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &:nth-child(2) {
        background-color: #e7701f;
        color: #000;
        margin-right: 0;
      }
    }
  }
  .Loader {
    display: none;
    position: absolute;
    top: 50%;
    width: 100%;
    background-color: black;
    opacity: 0.5;
    color: #fff;
    text-align: center;
  }
  @media only screen and (min-width: 867px) {
    .PopUpContent {
      width: 60%;
    }
    .buttonSection {
      button {
        font-size: 1.3rem;
        width: fit-content;
      }
    }
  }
`;
